import React from "react";
import { useNavigate } from "react-router-dom";

export default function TermsConditions() {
  const navigate = useNavigate();

  const handleAccept = () => {
    // Store acceptance in sessionStorage
    sessionStorage.setItem("termsAccepted", "true");
    // Navigate back to the signup page
    navigate("/signup");
  };

  return (
    <div className="terms-conditions-page">
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
        <div className="terms-content mb-6">
          <p>
            Welcome to Pipaan! By using our platform, you agree to the following terms and conditions...
          </p>
          <p>
            [Add your terms and conditions content here...]
          </p>
        </div>
        <button
          onClick={handleAccept}
          className="bg-green-500 text-white px-6 py-2 rounded-lg"
        >
          OK
        </button>
      </div>
    </div>
  );
}